import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_pairingSetIdAdapter204jlhkjchobz as get_pairingSetIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { KotlinInstantAdapter_instanceecp18tjhxm9b as KotlinInstantAdapter_instance } from '../../../../../../../../apollo-kotlin-adapters-apollo-adapters-core/com/apollographql/adapter/core/KotlinInstantAdapter.mjs';
import { PinnedPairInput_InputAdapter_instance136w4rd1cfalu as PinnedPairInput_InputAdapter_instance } from './PinnedPairInput_InputAdapter.mjs';
import {
  obj2vqjd1bjrpmyg as obj,
  list2lpjhmv1d2k19 as list,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePairAssignmentsInput3tgrc8c2zd524 as SavePairAssignmentsInput } from '../SavePairAssignmentsInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInput_InputAdapterClass;
function SavePairAssignmentsInput_InputAdapter() {
  if (SavePairAssignmentsInput_InputAdapterClass === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Input type used in output position');
      }
      toJson_p1hiod_k$(writer, customScalarAdapters, value) {
        writer.name_i73qwh_k$('partyId');
        get_partyIdAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.partyId_1);
        writer.name_i73qwh_k$('pairingSetId');
        get_pairingSetIdAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.pairingSetId_1);
        writer.name_i73qwh_k$('date');
        KotlinInstantAdapter_instance.toJson_h8vrwg_k$(writer, customScalarAdapters, value.date_1);
        writer.name_i73qwh_k$('pairs');
        list(obj(PinnedPairInput_InputAdapter_instance)).toJson_t3q33c_k$(writer, customScalarAdapters, value.pairs_1);
        var tmp = value.discordMessageId_1;
        if (tmp instanceof Present()) {
          writer.name_i73qwh_k$('discordMessageId');
          present(get_NullableStringAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.discordMessageId_1);
        }
        var tmp_0 = value.slackMessageId_1;
        if (tmp_0 instanceof Present()) {
          writer.name_i73qwh_k$('slackMessageId');
          present(get_NullableStringAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.slackMessageId_1);
        }
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_p1hiod_k$(writer, customScalarAdapters, value instanceof SavePairAssignmentsInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePairAssignmentsInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePairAssignmentsInput_InputAdapterClass = $;
  }
  return SavePairAssignmentsInput_InputAdapterClass;
}
var SavePairAssignmentsInput_InputAdapter_instance;
function SavePairAssignmentsInput_InputAdapter_getInstance() {
  return SavePairAssignmentsInput_InputAdapter_instance;
}
//region block: init
SavePairAssignmentsInput_InputAdapter_instance = new (SavePairAssignmentsInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePairAssignmentsInput_InputAdapter_instance as SavePairAssignmentsInput_InputAdapter_instance1gft199wl28jf,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput_InputAdapter.mjs.map
